import { ButtonPrimary, ButtonPseudo, InputText, Popup } from '@ui/src';
import { AccountsSettingsPopupTypes } from './types';

import cn from './styles.module.css';

const AccountSettingsPopup = ({
  debitBlock,
  setBlockWithdrawPopupVisible,
  onBlockWithdraw,
  account,
  blockWithdrawInProgress,
  blockWithdrawPopupVisible,
  blockUblockWithdrawalsError,
  creditBlock,
  setBlockTopupPopupVisible,
  onBlockTopup,
  blockTopupInProgress,
  blockTopupPopupVisible,
  blockUblockTopupError,
  closed,
  setClosePopupVisible,
  setComment,
  closePopupVisible,
  comment,
  closeOpenError,
  closeInProgress,
  onClose,
  setDebitBlock,
  setCreditBlock,
}: AccountsSettingsPopupTypes) => (
  <>
    <Popup
      title={`${!debitBlock ? 'Unblock' : 'Block'} all withdrawals?`}
      onCancelClick={() => {
        setBlockWithdrawPopupVisible(false);
        setDebitBlock(!debitBlock);
      }}
      onOkClick={() =>
        onBlockWithdraw({
          id: account?.id as string,
          debitBlock: !account?.debitBlock,
        })
      }
      cancelButtonText="Cancel"
      okButtonText={
        blockWithdrawInProgress
          ? 'Loading...'
          : `Yes, ${!debitBlock ? 'Unblock' : 'Block'}`
      }
      isVisible={blockWithdrawPopupVisible}
      parent={document.getElementById('account-popup') as HTMLElement}
    >
      <div>
        {blockUblockWithdrawalsError && (
          <div className={`${cn.accountError} ${cn.blockError}`}>
            {blockUblockWithdrawalsError}
          </div>
        )}
      </div>
    </Popup>
    <Popup
      title={`${!creditBlock ? 'Unblock' : 'Block'} the top-up of this account`}
      onCancelClick={() => {
        setBlockTopupPopupVisible(false);
        setCreditBlock(!creditBlock);
      }}
      onOkClick={() =>
        onBlockTopup({
          id: account?.id as string,
          creditBlock: !account?.creditBlock,
        })
      }
      cancelButtonText="Cancel"
      okButtonText={
        blockTopupInProgress
          ? 'Loading...'
          : `Yes, ${!creditBlock ? 'Unblock' : 'Block'}`
      }
      isVisible={blockTopupPopupVisible}
      parent={document.getElementById('account-popup') as HTMLElement}
    >
      <div>
        {blockUblockTopupError && (
          <div className={`${cn.accountError} ${cn.blockError}`}>
            {blockUblockTopupError}
          </div>
        )}
      </div>
    </Popup>
    <Popup
      title={`${closed ? 'Open' : 'Close'}  this account`}
      onCancelClick={() => {
        setClosePopupVisible(false);
        setComment('');
      }}
      isVisible={closePopupVisible}
      parent={document.getElementById('account-popup') as HTMLElement}
    >
      <>
        <div className={cn.commentWrapper}>
          <InputText
            name="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter comment"
          />
        </div>
        {closeOpenError && (
          <div className={cn.accountError}>{closeOpenError}</div>
        )}
        <div className={cn.commentControls}>
          <ButtonPseudo
            text="Cancel"
            onClick={() => {
              setClosePopupVisible(false);
              setComment('');
            }}
            bold
          />
          <ButtonPrimary
            text={
              closeInProgress
                ? 'Loading...'
                : `Yes, ${account?.closed ? 'open' : 'close'}`
            }
            onClick={() =>
              onClose({
                id: account?.id as string,
                comment,
                closed: !account?.closed,
              })
            }
            disabled={closeInProgress || !comment}
            bold
          />
        </div>
      </>
    </Popup>
    <div id="account-popup" />
  </>
);

export default AccountSettingsPopup;
